import styled from 'styled-components';
export const Container = styled.div.withConfig({
  displayName: "Navigationstyle__Container",
  componentId: "sc-1d9mv1d-0"
})(["", " .active{", "}"], {
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "center",
  "gap": "0.25rem"
}, {
  "fontWeight": "700",
  "--tw-text-opacity": "1",
  "color": "rgb(23 23 23 / var(--tw-text-opacity, 1))"
});
export const SegmentedWrapper = styled.div.withConfig({
  displayName: "Navigationstyle__SegmentedWrapper",
  componentId: "sc-1d9mv1d-1"
})(["", " transition:top 0.15s;"], {
  "position": "sticky",
  "top": "0px",
  "zIndex": "10"
});
export const Content = styled.span.withConfig({
  displayName: "Navigationstyle__Content",
  componentId: "sc-1d9mv1d-2"
})(["", ""], {
  "paddingTop": "0.5rem",
  "paddingBottom": "0.5rem",
  "fontSize": "1.5rem",
  "lineHeight": "2rem",
  "--tw-text-opacity": "1",
  "color": "rgb(88 88 88 / var(--tw-text-opacity, 1))"
});
export const RedDot = styled.div.withConfig({
  displayName: "Navigationstyle__RedDot",
  componentId: "sc-1d9mv1d-3"
})(["", ""], {
  "height": "0.5rem",
  "width": "0.5rem",
  "borderRadius": "9999px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(206 14 45 / var(--tw-bg-opacity, 1))"
});